import React from 'react';
interface CTAButtonProps {
  text: string;
  variant?: 'primary' | 'secondary';
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function CTAButton({
  text,
  variant = 'primary',
  className = '',
  onClick,
  href = '#buy-now'
}: CTAButtonProps) {
  const isExternal = href.startsWith('http');
  const classes = `
    relative group overflow-hidden rounded-xl font-bold text-center transition-all duration-300
    hover:scale-[1.02] active:scale-[0.98] shadow-lg inline-block cursor-pointer no-underline
    ${variant === 'primary' ? 'bg-gradient-to-r from-amber-500 to-amber-600 text-white hover:shadow-[0_0_25px_rgba(245,158,11,0.5)]' : 'bg-gradient-to-r from-amber-600 to-amber-700 text-white hover:shadow-[0_0_20px_rgba(217,119,6,0.5)]'}
    ${className}
  `;
  return <a href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} onClick={onClick} className={classes} data-id="element-73">
      <div className="absolute inset-0 bg-white/20 translate-y-[-100%] group-hover:translate-y-[100%] transition-transform duration-700 ease-in-out" data-id="element-74" />
      <div className="px-6 py-4 md:px-8 md:py-5 text-lg md:text-xl tracking-wide" data-id="element-75">
        {text}
      </div>
    </a>;
}